function normalizeBaseUrl(url) {
  if (!url || typeof url !== "string") return "";
  return url.trim().replace(/\/+$/, "");
}

export function getAuthBaseUrl() {
  const envBase = normalizeBaseUrl(import.meta.env.VITE_APP_URL);
  if (envBase) return envBase;

  if (typeof window !== "undefined" && window.location?.origin) {
    return normalizeBaseUrl(window.location.origin);
  }

  return "";
}

export function buildAuthRedirect(path = "/") {
  const base = getAuthBaseUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
